import { render, staticRenderFns } from "./BookingsToValidate.vue?vue&type=template&id=23e78c38&scoped=true"
import script from "./BookingsToValidate.vue?vue&type=script&lang=ts"
export * from "./BookingsToValidate.vue?vue&type=script&lang=ts"
import style0 from "./BookingsToValidate.vue?vue&type=style&index=0&id=23e78c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e78c38",
  null
  
)

export default component.exports